{
	"title": "Historia transakcji {{productName}}",
	"item": {
		"time": "Czas",
		"description": "Opis",
		"transactionId": "ID transakcji",
		"showIds": "Pokaż identyfikatory",
		"depositTitle": "Assurance DNV umożliwiające wpłatę do carbon bank",
		"depositDescription": "Gdy niezależna jednostka assurance 'DNV' potwierdzi w cyfrowym systemie Monitor-Report-Verify zmagazynowany wolumen wychwyconego CO\u2082, dokonywana jest nowa wpłata do carbon bank.",
		"withdrawalTitle": "Faktura dla dostawcy uruchamiająca wypłatę z carbon bank",
		"withdrawalDescription": "Wraz z zafakturowaniem materiału evoZero dostawcy wykonano wypłatę z carbon bank.",
		"transferTitle": "Przeniesienie redukcji emisji CO\u2082 na posiadacza deklaracji",
		"transferDescription": "Dostawca zainicjował przeniesienie redukcji emisji CO\u2082 na posiadacza deklaracji na podstawie wolumenu materiału evoZero wykorzystanego w dostarczonym produkcie."
	},
	"proofIdsModal": {
		"titleTransactions": "Wyświetl transakcje",
		"titleMeasurements": "Wyświetl pomiary",
		"paragraph1": "Jeden z etapów transakcji w {{productName}} polega na agregowaniu transakcji w rozproszonym rejestrze. Poniżej znajduje się lista linków do usług zewnętrznych, w których można przeglądać te transakcje.",
		"paragraph2": "Pamiętaj, że linki te prowadzą do zewnętrznych stron internetowych umożliwiających przeglądanie transakcji.",
		"open": "Otwórz",
		"close": "Zamknij"
	},
	"errors": {
		"fetch": "Nie udało się pobrać historii aktywności"
	}
}
